// @ts-ignore
process.hrtime = () => {
	const time = new Date().getTime()
	return [time, 0]
}
